export const ConfigFieldType = {
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
} as const

export type ConfigFieldTypeType =
  (typeof ConfigFieldType)[keyof typeof ConfigFieldType]

export type SchemaField = {
  type: ConfigFieldTypeType
  required?: boolean
  defaultValue?: any
  description?: string
}

export type Schema = Record<string, SchemaField>

export type ConfigEntry = {
  key: string
  value: string
  type: ConfigFieldTypeType
  error?: string
  showError?: boolean
  required?: boolean
  description?: string
}
